import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PricingOptionsModel } from '@app/modules/tf-pricing';

@Injectable()
export class ThermofisherPricingApiService {

    constructor(private http: HttpClient) {
    }

    retrievePrice(skus: string, opts: PricingOptionsModel): Observable<unknown> {
        return this.http.get(opts.pricingApi + skus + '?' + opts.getCacheVersionParams(), opts.getHeaders());
    }
}
